import {IAdapter} from '@drl/core/api/adapters/i-adapter';
import {ApiService} from '@drl/core/api/api.service';
import {  GetAPICommand } from '@drl/core/api/commands';
import {environment} from '@drl/env/environment';

export class GetCareCentralChatMessagesCountCommand<T> extends GetAPICommand<T> {
  constructor(apiService: ApiService, adapter: IAdapter<T>) {
    super(
      apiService,
      adapter,
      `${environment.chatApiUrl}/messages/care-central/msg-categories/count`,
    );
  }
}
